module.exports = __webpack_public_path__ + "media/svg-new/f-graph-7fb32e3c.svg";